<template>
	<div class="imgText">
		<div class="warp">
			<div class="account">
				改革开放四十年，迎来经济大发展，文化大繁荣。博物馆人锐意进取，以建设有中国特色的社会主义文化为目标，积极探索开拓藏品资源、提升科研水平、增强核心创造力。博物馆藏品建设工作得到社会广泛关注，海内外山西籍人士关心家乡博物馆建设热情高涨，尤其是钱自在先生捐赠文物数量之多、质量之精，令人叹为观止。
			</div>
			<div class="tab-content">
				<div>
					<dl v-for="(item,index) in allData" :key="index">
						<router-link tag="a" :to="{path:'pic',query:{id:item.id}}">
							<dt>
								<img :src="item.img" alt="">
							</dt>
						</router-link>
						<dd>
							<h3>{{item.title}}</h3>
							<p>{{item.etitle}}</p>
						</dd>
					</dl>
				</div>
			</div>
		</div>
		<div class="goback" @click="goback"></div>
	</div>
</template>
<script type="text/javascript">
    export default {
        data(){
            return{
                allData:[{
                    id:'unit3_01',
                    img:require('../static/imgs/proList3/proList3_01.jpg'),
                    title:'《风竹图》轴',
                    etitle:'顾安（元）',
                    size:'纵106厘米，横33.5厘米',
                    donor:'1986年钱自在先生捐赠'
                },{
                    id:'unit3_02',
                    img:require('../static/imgs/proList3/proList3_02.jpg'),
                    title:'《起蛟图》轴',
                    etitle:'无款（元）',
                    size:'纵95.5厘米，横40.5厘米',
                    donor:'1986年钱自在先生捐赠'
                },{
                    id:'unit3_03',
                    img:require('../static/imgs/proList3/proList3_03.jpg'),
                    title:'《祇园大会图》卷',
                    etitle:'髪僧（元）',
                    size:'纵37.2厘米，横1889厘米',
                    donor:'1986年钱自在先生捐献'
                },{
                    id:'unit3_04',
                    img:require('../static/imgs/proList3/proList3_04.jpg'),
                    title:'《兰亭修禊图》轴',
                    etitle:'无款（明）',
                    size:'纵162.5厘米，横88厘米',
                    donor:'1986年钱自在先生捐赠'
                },{
                    id:'unit3_05',
                    img:require('../static/imgs/proList3/proList3_05.jpg'),
                    title:'白描《罗汉渡海图》卷',
                    etitle:'无款（明）',
                    size:'纵27厘米，横975厘米',
                    donor:'1986年钱自在先生捐赠'
                },{
                    id:'unit3_06',
                    img:require('../static/imgs/proList3/proList3_06.jpg'),
                    title:'行书七绝诗轴',
                    etitle:'于成龙（清）',
                    size:'纵165厘米，横43厘米',
                    donor:'1986年钱自在先生捐赠'
                },{
                    id:'unit3_07',
                    img:require('../static/imgs/proList3/proList3_07.jpg'),
                    title:'楷书录王应麟《困学纪闻》句轴',
                    etitle:'钱沣（清）',
                    size:'纵57厘米，横22厘米',
                    donor:'1986年钱自在先生捐赠'
                },{
                    id:'unit3_08',
                    img:require('../static/imgs/proList3/proList3_08.jpg'),
                    title:'《盆梅图》轴',
                    etitle:'伊秉绶（清）',
                    size:'纵53厘米，横32厘米',
                    donor:'1986年钱自在先生捐赠'
                },{
                    id:'unit3_09',
                    img:require('../static/imgs/proList3/proList3_09.jpg'),
                    title:'草书《千字文》册',
                    etitle:'傅山（清）',
                    size:'纵24.7厘米，横25.5厘米',
                    donor:'1993年赵正楷先生捐赠'
                },{
                    id:'unit3_10',
                    img:require('../static/imgs/proList3/proList3_10.jpg'),
                    title:'楷书《阿难吟》册',
                    etitle:'傅山（清）',
                    size:'纵22.5厘米，横12.5厘米',
                    donor:'1993年赵正楷先生捐赠'
                },]
            }
        },
        mounted(){
            this.curdata=this.allData;
        },
        methods:{
            goback(){
                if(window.history.length == 1){
                    this.$router.push({path:"/"})
                }else{
                    this.$router.go(-1)
                }
            }
        }
    }
</script>
<style scoped>
	.imgText{
		min-height:100%;
		background-color: #f1f1f1;
	}
	.goback{
		width: 1.63rem;
		height: 1.63rem;
		background:url(../static/imgs/goback.png);
		background-size: 100% 100%;
		position: fixed;
		right: .17rem;
		top:50%;
		margin-top: -.815rem;
	}
	.warp{
		margin: 0 auto;
		padding-top: .2rem;
	}
	.account{
		background: url('../static/imgs/account.png') no-repeat center / cover;
		width:6.3rem;
		height:3.22rem;
		margin:0 .24rem .4rem;
		padding:.3rem .36rem;
		font-size: .28rem;
		line-height: .46rem;
		letter-spacing: .02rem;
		color:#555;
	}
	.title{
		width: 100%;
		text-align: left;
		font-size:20px;
		position: relative;
		margin-bottom: .8rem;
	}
	.title span{
		text-indent:0.14rem;
		letter-spacing: 3px;
		display: inline-block;
		z-index: 3;
		position: absolute;
	}
	.title em{
		display: inline-block;
		width: 0.85rem;
		height:9px;
		background: #e6bb70;
		left: 0.20rem;
		position: absolute;
		z-index: 1;
		top:10px;
	}
	.cont{
		width: 90%;
		margin: 0 auto;
	}
	.cont p{
		font-size: 16px;
		color:#666666;
		line-height: 30px;
		text-align: justify;
		margin-bottom: .10rem;
	}
	.cont dl{
		width: 100%;
		margin-bottom:.10rem;
	}
	.cont dl dt img{
		width: 100%;
	}
	.cont dl dd{
		font-size:14px;
		color:#adadad;
		margin-top: 0.15rem;
		line-height: 20px;
	}
	.butn{
		/*background:url(../static/bj1.png);*/
		height:.4rem;
		background-size: 100%;
		margin-top:.25rem;
		position: relative;
	}
	.btnC{
		width: 0.45rem;
		height: 0.23rem;
		border-radius: 50px;
		background:#fff;
		box-shadow: 0px 1px 15px #ededed;
		text-align: center;
		line-height: 0.23rem;
		margin: 0 auto;
		margin-top: -0.11rem;
		position: absolute;
		left: 50%;
		margin-left: -0.25rem;
		color:#e6bb70;
	}
	.activeClass{
		height: 2rem;
		overflow:hidden;
	}
	.hideClass{
		height: auto;
	}
	.tab-tilte{
		width:1500px;
	}
	.tab-tilte li{
		float: left;
		width:1rem;
		padding: 10px 0;
		text-align: center;
		cursor: pointer;
		color:#cdcdcd;
		font-size: 18px;
		font-weight: bolder;
	}
	/* 点击对应的标题添加对应的背景颜色 */
	.tab-tilte .active{
		color: #e6bb70;
	}
	.tab-content div{
		padding-right: .4rem;
		margin-top:.2rem;
		column-count:2;
		padding-left: .03rem;
	}
	.tab-content div dl{
		margin-left: .2rem;
		width:3.4rem;
		background: #fff;
		display: inline-block;
		margin-bottom: .2rem;
		border-radius: .1rem;
	}
	.tab-content div dl dt{
		justify-content: center;
		align-items: center;
	}
	.tab-content div dl dt img{
		max-width:100%;
		max-height: 100%;
		border-radius: 4px 4px 0 0;
	}
	.tab-content div dl dd{
		padding-bottom: .46rem;
		background:#fff;
	}
	.tab-content h3{padding:.29rem .21rem .2rem;font-size: .28rem;line-height: normal;font-weight: bold;color:#333;}
	.tab-content p{padding:0 .21rem;color:#666;font-size: .24rem;}

</style>